import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-odoo-solution',
  templateUrl: './odoo-solution.component.html',
  styleUrls: ['./odoo-solution.component.scss']
})
export class OdooSolutionComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Discover our comprehensive Odoo solutions at OSIT. We specialize in implementing and customizing Odoo ERP systems to streamline your business operations in Riyadh, Saudi Arabia. Explore how our Odoo expertise can enhance your company efficiency and growth.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }

}
